import numeral from 'numeral';
import immutable from 'object-path-immutable';
import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import ActionsBar from '../../../components/ActionsBar';
import * as K from '../redux/SalesConstants';
import OperatorsName from '../../../components/OperatorsName/OperatorsName';

class operatorsPaymentSale extends Component {
  handleEdit = (index) => {
    var newSale = immutable.set(
      this.props.Sales,
      ['indexPaymentToEdit'],
      index
    );
    newSale = immutable.set(
      newSale,
      ['dataToEdit', 'operatorsPayment'],
      this.props.Sales.operatorsPaymentSale[index]
    );

    this.props.dispatch({
      type: K.SETSTATE,
      payload: newSale,
    });

    this.props.dispatch({
      type: K.OPEN_MODAL_ADD,
      payload: 'operatorsPayment',
    });
  };

  handleDelete = (index) => {
    var newArray = immutable.del(this.props.Sales, [
      'operatorsPaymentSale',
      index,
    ]);

    this.props.dispatch({
      type: K.SETSTATE,
      payload: newArray,
    });
  };

  handleAdd = () => {
    this.props.dispatch({
      type: K.OPEN_MODAL_ADD,
      payload: 'operatorsPayment',
    });
  };

  render() {
    let { Sales } = this.props;
    return (
      <div style={{ textAlign: 'justify' }}>
        <Row>
          <Col md={12}>
            {Sales.operatorsPaymentSale.map((service, index) => {
              return (
                <div key={index} style={{ marginBottom: '30px' }}>
                  <ActionsBar
                    onEdit={() => this.handleEdit(index)}
                    // onDelete={() => this.handleDelete(index)}
                  />
                  <br />
                  <Row>
                    <Col md={3}>
                      <div className="form-group">
                        <label style={{ fontWeight: 'bold' }} htmlFor="client">
                          OPERADOR
                        </label>
                        <br />
                        <OperatorsName id={service.operator} />
                      </div>
                    </Col>
                    <Col md={3}>
                      <div className="form-group">
                        <label style={{ fontWeight: 'bold' }} htmlFor="client">
                          MONTO
                        </label>
                        <br />
                        <span>
                          {service.nationalCurrency !== null
                            ? numeral(service.nationalCurrency).format(
                                '$0,0.00'
                              )
                            : ''}
                        </span>
                      </div>
                    </Col>
                    <Col md={3}>
                      <div className="form-group">
                        <label style={{ fontWeight: 'bold' }} htmlFor="client">
                          PAGADO
                        </label>
                        <br />
                        <span>
                          {service.nationalCurrency !== null
                            ? numeral(service.totalPayed).format('$0,0.00')
                            : 0}
                        </span>
                      </div>
                    </Col>
                    <Col md={3}>
                      <div className="form-group">
                        <label style={{ fontWeight: 'bold' }} htmlFor="client">
                          Estatus
                        </label>
                        <br />
                        {Number(service.nationalCurrency).toFixed(2) ===
                        Number(service.totalPayed).toFixed(2) ? (
                          <i
                            style={{
                              fontSize: 30,
                              color: 'green',
                            }}
                            className="fa fa-check-circle-o"
                            aria-hidden="true"
                          />
                        ) : (
                          <i
                            style={{
                              fontSize: 30,
                              color: 'red',
                            }}
                            className="fa fa-times-circle-o"
                            aria-hidden="true"
                          />
                        )}
                      </div>
                    </Col>
                  </Row>

                  <Row></Row>
                </div>
              );
            })}
          </Col>
        </Row>
      </div>
    );
  }
}

export default connect((state) => ({ Sales: state.Sales }))(
  operatorsPaymentSale
);



// WEBPACK FOOTER //
// ./src/views/Sales/cardsSale/operatorsPaymentSale.js